import React, { Component } from 'react';
import { Control, Form, Errors } from 'react-redux-form';
import { Search, MapPin, Flag } from '../../icons';
import { Loading } from '../common/LoadingComponent';
import LocationSearchInput from '../common/LocationSearchCities';

const required = (val) => val && val.length > 2;

class SearchAnnouncements extends Component {
    constructor(props) {
        super(props);
        this.handleSearchAnnouncements = this.handleSearchAnnouncements.bind(this);
    }

    handleSearchAnnouncements(values) {
        this.props.fetchAnnouncements(values.departure, values.destination, values.dateDeparture);
    }

    render() {
        if (this.props.isSearchAnnouncements) {
            return (
                <div className="search-page">
                    <div className="search-page-hero">
                        <div className="container text-center">
                            <Loading />
                            <p style={{ color: 'rgba(255,255,255,0.7)', marginTop: 16 }}>Recherche en cours…</p>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="search-page">
                <div className="search-page-hero">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-7 text-center">
                                <p className="page-hero__eyebrow">Recherche</p>
                                <h1 className="page-hero__title">Où va votre colis ?</h1>
                                <p className="page-hero__subtitle">
                                    Trouvez un voyageur qui fait le même trajet et envoyez votre colis en toute simplicité.
                                </p>
                                <div className="search-page-card">
                                    <Form validateOn="submit" model="searchTripsForm"
                                        onSubmit={(values) => this.handleSearchAnnouncements(values)}
                                        validators={{ departure: { required }, destination: { required } }}>
                                        <div className="row align-items-end">
                                            <div className="col-12 col-md-4 mb-3 mb-md-0">
                                                <label className="search-page__label">
                                                    <MapPin size={13} strokeWidth={2.5} color="var(--primary)" style={{ verticalAlign: 'middle', marginRight: 4 }} />
                                                    Départ
                                                </label>
                                                <LocationSearchInput model=".departure" id="departure" name="departure"
                                                    placeholder="Paris, Lyon…" formName="searchTripsForm" />
                                                <Errors model=".departure" className="errors"
                                                    messages={{ required: 'Saisissez une ville de départ.' }} />
                                            </div>
                                            <div className="col-12 col-md-4 mb-3 mb-md-0">
                                                <label className="search-page__label">
                                                    <Flag size={13} strokeWidth={2.5} color="var(--primary)" style={{ verticalAlign: 'middle', marginRight: 4 }} />
                                                    Destination
                                                </label>
                                                <LocationSearchInput model=".destination" id="destination" name="destination"
                                                    placeholder="Casablanca, Bruxelles…" formName="searchTripsForm" />
                                                <Errors model=".destination" className="errors"
                                                    messages={{ required: 'Saisissez une ville de destination.' }} />
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <Control.button className="btn btn-primary btn-search" model="searchTripsForm" type="submit">
                                                    <Search size={16} strokeWidth={2.5} />&nbsp; Rechercher
                                                </Control.button>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchAnnouncements;
